export { SellerCollectsTag } from './SellerCollectsTag'
